// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"457c9f49261539850626928c216ec4d0791a5eb8"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  // Tip: To avoiding unnecessary logs during development set up NEXT_PUBLIC_DISABLE_SENTRY=true
  enabled: !Boolean(process.env.NEXT_PUBLIC_DISABLE_SENTRY),
  // Tip: When debugging locally set up a custom NEXT_PUBLIC_ENVIRONMENT that you will find in the Sentry dashboard
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 0.2 : 0,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [window.location.origin],
    }),
    Sentry.replayCanvasIntegration(),
  ],
  replaysSessionSampleRate: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' ? 1.0 : 0,
  replaysOnErrorSampleRate: 1.0,
});
